/**
 * Focus an Ionic input after its native `<input>` is ready.
 * `setFocus()` alone is a no-op when `nativeInput` is not yet rendered
 * (common after remount / `@if` / navigation).
 */
export async function focusIonInput(
  input:
    | {
        getInputElement: () => Promise<HTMLInputElement | undefined>;
        setFocus: () => Promise<void>;
      }
    | null
    | undefined,
): Promise<void> {
  if (!input) return;
  await input.getInputElement();
  await input.setFocus();
}
